module.exports = __webpack_public_path__ + "img/rotateicon.60f91876.svg";